import { Injectable } from '@angular/core';

@Injectable()
export class InfiniteScrollService {
    public take: number;
    public skip: number;

    private readonly DefaultTake = 30;

    constructor() {
        this.take = this.DefaultTake;
        this.skip = 0;
    }

    public takeNext(): void {
        this.skip += this.take;
    }
}
